// Gestiona los siguientes eventos:
// - open-sidebar
// - close-sidebar
const EventBus = new Vue()

export default EventBus
